import {
  Flex,
  HorizontalSpacing,
  RemoteImage,
  Typography,
} from '@banhala/ui-kit';
import { StyleSheet, View } from 'react-native';
import type { MumulLiveProfileStatus } from 'shared/src/api';
import { StoryRing } from 'shared/src/component/StoryRing/StoryRing';
import { getMumulLiveStatusDisplay } from './constants/mumulLiveStatusDisplay';

const RING_SIZE = 56;
const IMAGE_SIZE = 50;

type Props = {
  status: MumulLiveProfileStatus;
  marketName: string;
  marketImageUrl: string;
  onPress: () => void;
};

/**
 * EXP1789 변형군 B: 간판(브랜드/IP) 영역에 노출하는 무물라이브 프로필 행.
 * 상태별 테두리/점/문구로 표시한다. DEFAULT 는 렌더하지 않는다.
 */
export const MumulLiveProfile = ({
  status,
  marketName,
  marketImageUrl,
  onPress,
}: Props) => {
  const display = getMumulLiveStatusDisplay(status);
  if (display == null) {
    return null;
  }

  const profileImage = (
    <Flex
      width={IMAGE_SIZE}
      height={IMAGE_SIZE}
      borderRadius={IMAGE_SIZE / 2}
      overflow={'hidden'}
    >
      <RemoteImage width={IMAGE_SIZE} height={IMAGE_SIZE} uri={marketImageUrl} />
    </Flex>
  );

  return (
    <Flex.Row
      onPress={onPress}
      alignItems={'center'}
      padding={{ left: 16, right: 8, vertical: 12 }}
    >
      {status === 'HAS_UNREAD_STORY' ? (
        <StoryRing size={RING_SIZE} strokeWidth={1.5} color={display.ringColor}>
          {profileImage}
        </StoryRing>
      ) : (
        // borderWidth 는 상수로 고정하고 borderColor 만 동적 변경 (Android 첫 렌더 borderRadius 이슈 회피)
        <View style={[styles.ring, { borderColor: display.ringColor }]}>
          {profileImage}
        </View>
      )}

      <HorizontalSpacing size={10} />

      <Flex flex={1} gap={4}>
        <Typography
          type={'subtitle1'}
          color={'content_primary'}
          numberOfLines={1}
        >
          {marketName}
        </Typography>
        <Flex.Row alignItems={'center'} gap={4} padding={{ left: 2 }}>
          <Flex
            width={6}
            height={6}
            borderRadius={3}
            backgroundColorValue={display.dotColor}
          />
          <Typography
            type={'body2'}
            rawColor={display.textColor}
            numberOfLines={1}
          >
            {display.text}
          </Typography>
        </Flex.Row>
      </Flex>
    </Flex.Row>
  );
};

const styles = StyleSheet.create({
  ring: {
    width: RING_SIZE,
    height: RING_SIZE,
    borderRadius: RING_SIZE / 2,
    borderWidth: 1.5,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
